import { render, staticRenderFns } from "./NavigateWeb.vue?vue&type=template&id=c9fb9b44&scoped=true&"
import script from "./NavigateWeb.vue?vue&type=script&lang=js&"
export * from "./NavigateWeb.vue?vue&type=script&lang=js&"
import style0 from "./NavigateWeb.vue?vue&type=style&index=0&id=c9fb9b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fb9b44",
  null
  
)

export default component.exports